import axios from 'axios'
import FileSaver from 'file-saver'
import qs from 'qs'
import fn from '../../utils/functions'
import dayjs from 'dayjs';

// Normaliza fechas en profundidad para evitar que qs.stringify destruya objetos Dayjs
export function convertDates(obj) {
  if (obj == null) return obj;

  // Detecta Day.js correctamente
  if (dayjs.isDayjs(obj)) {
    return obj.toISOString();
  }

  // Detecta Date nativo
  if (obj instanceof Date) {
    return obj.toISOString();
  }

  // Arrays → recorrer
  if (Array.isArray(obj)) {
    return obj.map(item => convertDates(item));
  }

  // Objetos → recorrer recursivamente
  if (typeof obj === 'object') {
    const newObj = {};
    for (const key in obj) {
      newObj[key] = convertDates(obj[key]);
    }
    return newObj;
  }

  
  return obj;
}

function initSession () {
  const session = {
    documentation: {
      tableData: [],
      totalDocumentation: 0
    },
    queryDocumentation: {
      page: 0,
      size: 20,
      sort: 'name,ASC'
    },
    listSelectedFiltersDocumentation: [],
  }
  return session
}

function initLocal () {
  const local = {
    isShowServicioDocumentacion: true,
    isShowCategoriaDocumentacion: true,
    isShowIdiomaDocumentacion: true,
    isShowNombreDocumentacion: true
  }
  return local
}
function setByUserLocalDocumentacion () {
  const local = {    
    isShowServicioDocumentacion: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).documentacion.isShowServicioDocumentacion,
    isShowCategoriaDocumentacion: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).documentacion.isShowCategoriaDocumentacion,
    isShowIdiomaDocumentacion: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).documentacion.isShowIdiomaDocumentacion,
    isShowNombreDocumentacion: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).documentacion.isShowNombreDocumentacion
  }
  return local
}

const state = {
  local: {
    optionsFilterDocumentationCategories: [],
    optionsFilterLanguages: [],
    isShowServicioDocumentacion: true,
    isShowCategoriaDocumentacion: true,
    isShowIdiomaDocumentacion: true,
    isShowNombreDocumentacion: true
  },
  session: initSession()
}

const getters = {
  documentation: state => {
    return state.session.documentation
  },
  queryDocumentation: state => {
    return state.session.queryDocumentation
  },
  listSelectedFiltersDocumentation: state => {
    return state.session.listSelectedFiltersDocumentation
  },
  optionsFilterDocumentationCategories: state => {
    return state.session.optionsFilterDocumentationCategories
  },
  optionsFilterLanguages: state => {
    return state.session.optionsFilterLanguages
  },
  isShowServicioDocumentacion: state => {
    return state.local.isShowServicioDocumentacion
  },
  isShowCategoriaDocumentacion: state => {
    return state.local.isShowCategoriaDocumentacion
  },
  isShowIdiomaDocumentacion: state => {
    return state.local.isShowIdiomaDocumentacion
  },
  isShowNombreDocumentacion: state => {
    return state.local.isShowNombreDocumentacion
  }
}

const actions = {
   // Crear key Usuario
   setUserNameDocumentacion ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalDocumentacion()
    }
  },

  isNewVersionDocumentacionLocalState ({ state }, localStorage) {
    return fn.isNewVersion(state, localStorage.documentacion)
  },
  async getDocumentation ({
    commit, rootState
  }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
          rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/documentation',
        params: data.query
      })

      commit('DOCUMENTATION_STATE', {
        tableData: response.data.content,
        totalDocumentation: response.data.totalElements
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async getDocumentationById ({
    commit, rootState
  }, idDocumentation) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/documentation/' + idDocumentation
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async handleUploadDocumentation ({
    commit, rootState
  }, params) {
    console.log('Id ', params.id)
    console.log('CategoryId ', params.categoryId)
    console.log('ProjectId ', params.projectId)
    const formData = new FormData()
    
    if (params.documentation?.raw ) {
      formData.append('documentation', params.documentation.raw)    
    } 
    if (params.id && params.id !== null) {
      formData.append('id', params.id)
    } else {
      formData.append('id', '')
    }
    if (params.name !== null) {
      formData.append('name', params.name)
    }
    formData.append('url', params.url === null ? '' : params.url)
    if (params.languageId !== null) {
        formData.append('languageId', params.languageId)
    }
    if (params.projectId !== null) {
      formData.append('projectId', params.projectId)
    }
    if (params.categoryId !== null) {
      formData.append('categoryId', params.categoryId)
    }
    formData.append('deletefile', params.deletefile === null ? false : params.deletefile)
    try {
      let response = await axios({
          method: 'POST',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          url: 'documentation/upload',
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          data: formData
      })
      console.log('respose--- ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR handleUploadDocumentation--- ', error.response)
      throw error.response
    }
  },
  async getDocumentationCategories ({
    commit, rootState
  }) {
    try {
      let response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/documentation/categories'
      })      
      commit('OPTIONS_FILTER_DOCUMENTATION_CATEGORIES', response.data)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR getDocumentationCategories --- ', error.response)
      throw error.response
    }
  },
  async getLanguages ({
    commit, rootState
  }) {
    try {
      let response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/documentation/languages'
      })
      commit('OPTIONS_FILTER_LANGUAGES', response.data)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR getLanguages --- ', error.response)
      throw error.response
    }
  },  
  async deleteDocument ({
    commit, rootState
  }, idDocumentation) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: `/documentation/${idDocumentation}/deleteDocument`
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async downloadDocumentationMultiple ({
    commit, rootState
  }, documentationIds) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/documentation/downloadMulti',
        params: {
          documentationIds: documentationIds
        },
        responseType: 'blob',
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false })
        }
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })

      const filename = fn.extractFilename(response.headers['content-disposition'], 'documentos.zip')
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  documentationState: ({ commit }, payload) => {
    commit('DOCUMENTATION_STATE', payload)
  },
  queryDocumentationState: ({ commit }, payload) => {
    commit('QUERY_DOCUMENTATION_STATE', payload)
  },
  optionsFilterDocumentationCategoriesState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DOCUMENTATION_CATEGORIES', payload)
  },
  optionsFilterLanguagesState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_LANGUAGES', payload)
  },
  listSelectedFiltersDocumentationState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_DOCUMENTATION', payload)
  },
  isShowServicioDocumentacionAction: ({ commit }, payload) => {
    commit('IS_SHOW_SERVICIO_DOCUMENTATION', payload)
  },
  isShowCategoriaDocumentacionAction: ({ commit }, payload) => {
    commit('IS_SHOW_CATEGORIA_DOCUMENTATION', payload)
  },
  isShowIdiomaDocumentacionAction: ({ commit }, payload) => {
    commit('IS_SHOW_IDIOMA_DOCUMENTATION', payload)
  },
  isShowNombreDocumentacionAction: ({ commit }, payload) => {
    commit('IS_SHOW_NOMBRE_DOCUMENTATION', payload)
  }
}

const mutations = {
  resetSessionDocumentacion (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  'DOCUMENTATION_STATE' (state, payload) {
    state.session.documentation = payload
  },
  'QUERY_DOCUMENTATION_STATE' (state, payload) {
    state.session.queryDocumentation = payload
  },
  'OPTIONS_FILTER_DOCUMENTATION_CATEGORIES' (state, payload) {
    state.session.optionsFilterDocumentationCategories = payload
  },
  'OPTIONS_FILTER_LANGUAGES' (state, payload) {
    state.session.optionsFilterLanguages = payload
  },
  'LIST_SELECTED_FILTERS_DOCUMENTATION' (state, payload) {
    state.session.listSelectedFiltersDocumentation = payload
  },
  'IS_SHOW_SERVICIO_DOCUMENTATION' (state, payload) {
    state.local.isShowServicioDocumentacion = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.documentacion.isShowServicioDocumentacion = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CATEGORIA_DOCUMENTATION' (state, payload) {
    state.local.isShowCategoriaDocumentacion = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.documentacion.isShowCategoriaDocumentacion = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_IDIOMA_DOCUMENTATION' (state, payload) {
    state.local.isShowIdiomaDocumentacion = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.documentacion.isShowIdiomaDocumentacion = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NOMBRE_DOCUMENTATION' (state, payload) {
    state.local.isShowNombreDocumentacion = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.documentacion.isShowNombreDocumentacion = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }



}

export default {
  state,
  getters,
  actions,
  mutations
}
